module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-settings/147assets/fonts/8a2acdb7f8770929fdc16509409de3af.svg";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-sass/assets/fonts/font-awesome/fontawesome-webfont.svg?v=4.7.0
// module id = 760
// module chunks = 4